import React from 'react';

type VideoSectionProps = {
  url: string;
  jobPostData: any;
  videoRef: React.RefObject<HTMLVideoElement>;
  isPlaying: boolean;
  handlePlayPause: () => void;
};

export const VideoSection = ({
  url,
  jobPostData,
  videoRef,
  isPlaying,
  handlePlayPause,
}: VideoSectionProps) => {
  if (!url) return null;

  return (
    <div className='mb-6'>
      { jobPostData?.videoTitle && (
        <h3 className='text-lg font-semibold text-gray-900 mb-2'>
          { jobPostData.videoTitle }
        </h3>
      ) }
      { jobPostData?.videoDescription && (
        <p className='text-sm text-gray-600 mb-4'>
          { jobPostData.videoDescription }
        </p>
      ) }
      <div className='bg-gray-50 rounded-xl p-4 border border-gray-100'>
        <video
            ref={videoRef}
            className='w-full rounded-lg mb-3 shadow-sm bg-black'
            controls
            preload='metadata'
            playsInline
        >
          <source src={url} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
        <button
            onClick={handlePlayPause}
            className='w-full px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-all duration-200 font-medium shadow-sm hover:shadow-md'
        >
          <span className='flex items-center justify-center gap-2'>
            { isPlaying ? (
              <>
                <svg className='w-4 h-4' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M6 4h4v16H6V4zm8 0h4v16h-4V4z' />
                </svg>
                Pause
              </>
            ) : (
              <>
                <svg className='w-4 h-4' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M8 5v14l11-7z' />
                </svg>
                Play
              </>
            ) }
          </span>
        </button>
      </div>
    </div>
  );
};
